// extracted by mini-css-extract-plugin
module.exports = {"wrap":"upload_wrap__3mu0o","button":"upload_button__FaV6v","upload":"upload_upload__1T876","uploadLabel":"upload_uploadLabel__7yV1w","progress":"upload_progress__10zV9"};